var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import styled from "styled-components";
import Icon from "@irati/ui/src/Icon";
import { Caption } from "@irati/ui/src/Labels";
import Flex from "@irati/ui/src/Flex";
var Wrapper = styled(Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", " {\n    margin-right: 5px;\n    fill: ", ";\n  }\n"], ["\n  ", " {\n    margin-right: 5px;\n    fill: ", ";\n  }\n"])), Icon, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.black;
});
var Online = /** @class */ (function (_super) {
    __extends(Online, _super);
    function Online() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Online.prototype.render = function () {
        return (React.createElement(Wrapper, { alignItems: "center", flex: "0 0 auto" },
            React.createElement(Icon, { icon: "online" }),
            React.createElement(Caption, { flush: true }, this.props.text)));
    };
    return Online;
}(PureComponent));
export default Online;
var templateObject_1;
